import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-ia-atd-setting',
  templateUrl: './ia-atd-setting.component.html',
  styleUrls: ['./ia-atd-setting.component.scss']
})
export class IaAtdSettingComponent implements OnInit {

  IAAtdSetting: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  Table = false;
  APIService: any;
  StudentTable: [];
  colrChang = false;
  CountTable: [];
  StuArray: FormArray;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  CourseList: any;
  SaveBtn = false;
  UpdateBtn = false;
  BranchShow = false;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  CountTableForApp: any[];
  inteckCount: number;
  assignTableData: any[];
  Student: any;
  errMsg: any;
  currentDate: Date;
  Session: any;
  filteredListExam: any;
  ExamList: any;
  BranchList: any;
  filteredListBranch: any;
  emid: any;
  subjectList = []
  filteredsubjectList
  exsubjectData
  savedpayload: any;
  tableData: any;
  userPermission: any;
  utp: string;
  SubCode: any;
  IaAtdCreate = true;
  IaAtdUpdate = true;
  saveDisable = false;
  updateDisable: boolean;
  UserCollege
  // jsonData: any;
  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService, public datepipe: DatePipe,

  ) { this.APIService = environment.serviceUrl; }


  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Practical Attendance' && element.PCreate == false) {
          this.IaAtdCreate = false;
        }
        if (element.PageName == 'Practical Attendance' && element.PUpdate == false) {
          this.IaAtdUpdate = false;
        }

      });
    }
    this.saveDisable = false
    this.updateDisable = false
    this.SaveBtn = false;
    this.UpdateBtn = false;
    this.BranchShow = false;
    this.Table = false
    this.submitButton = true;
    this.editButton = false;
    this.IAAtdSetting = this.fb.group({
      CgCode: new FormControl(''),
      CoCode: new FormControl(''),
      EmId: new FormControl(''),
      StrId: new FormControl(0),
      SessionId: new FormControl(''),
      EsParentId: new FormControl(''),
      StuArray: new FormArray([]),
    });
    this.fetchSession('');
    this.currentDate = new Date();
    this.getCollegeData();
  }

  getStuArrayControls() {
    return (this.IAAtdSetting.get('StuArray') as FormArray).controls;
  }



  fetchSession(id) {
    this.Session = 0
    this.spinner.show();
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })

  }

  getCollegeData() {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = this.UserCollege
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();

    }, (ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

  SetSession(data) {
    this.Session = data
    this.ExamList = [];
    this.CourseList = [];
    this.BranchList = [];
  }

  getCourse(data) {
    this.Table = false;
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    this.IAAtdSetting.controls['CoCode'].setValue('');
    this.IAAtdSetting.controls['EmId'].setValue('');
    this.IAAtdSetting.controls['StrId'].setValue('');
    this.IAAtdSetting.controls['EsParentId'].setValue('');
    this.BranchShow = false;
    this.spinner.show();
     const payload = {};
    payload['CgCode'] = data;
    payload['CoCode'] = '';
    // getSessionColgCo
    this.umsService.getCollegeCourse(payload).subscribe((res) => {
       if (res.status) {
        const mappedCourseCodes = new Set(res.data.map((item: any) => item.CoCode));

        const payload2 = { SearchString: '' };
        this.umsService.getCourse(payload2).subscribe({
          next: (allres) => {
            this.CourseList = allres.data.filter((course: any) =>
              mappedCourseCodes.has(course.CoCode)
            );

            this.filteredListCourse = [...this.CourseList];
            this.spinner.hide();
          },
          error: () => {
            this.CourseList = [];
            this.spinner.hide();
          }
        });
      } 
      else{
        this.CourseList = [];
      this.spinner.hide();
      }

    }, (ERROR: HttpErrorResponse) => {
      this.CourseList = [];
      this.spinner.hide();
    })
  }

  getExam(data) {
    this.Table = false;
    this.IAAtdSetting.controls['EmId'].setValue('');
    this.IAAtdSetting.controls['StrId'].setValue('');
    this.IAAtdSetting.controls['EsParentId'].setValue('');
    this.BranchShow = false;
    this.spinner.show();
    const payload = {};
    payload['EmCoCode'] = data;
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.ExamList = res.data;
        this.filteredListExam = this.ExamList.slice();
      }
      else {
        this.ExamList.data = [];
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }



  fetchBranch(data) {
    this.emid = data;
    const payload = {};
    payload['EmId'] = data;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }

  getExmSub(data) {
    this.IAAtdSetting.controls['StrId'].setValue('');
    this.IAAtdSetting.controls['EsParentId'].setValue('');
    this.emid = 0;
    this.Table = false;
    if (data.EmStreams == "Y") {
      this.BranchShow = true;
      this.IAAtdSetting.controls['StrId'].setValue(0)
      this.fetchBranch(data.EmId);
      // this.emid = e.EmId;
    }

    else {
      this.IAAtdSetting.controls['StrId'].setValue(0)
      this.BranchShow = false;
      // 
      // this.getAttendance(data.EmId, 0);
      this.subjects(data.EmId, 0)

    }
  }

  subjects(EmId, StrId) {
    this.SubCode = ''
    const payload = {};
    payload['EsEmId'] = EmId;
    payload['EsStrId'] = StrId;
    payload['EsType'] = 'S'
    this.umsService.getSubjectList(payload).subscribe(res => {
      this.subjectList = res.data;
      this.filteredsubjectList = this.subjectList.slice();
    });
  }

  getBrSub(data) {
    this.IAAtdSetting.controls['EsParentId'].setValue('');
    // this.getAttendance(this.emid, data);
    this.filteredsubjectList = [];
    this.subjects(this.emid, data)
  }

  ShowTable(data, SubCode) {
    this.SubCode = SubCode;
    this.savedpayload = this.IAAtdSetting.value
    this.StuArray = this.IAAtdSetting.get('StuArray') as FormArray;
    this.StuArray.clear();
    const payload = {};
    this.Table = false;
    payload['CgCode'] = this.savedpayload.CgCode;
    payload['CoCode'] = this.savedpayload.CoCode;
    payload['EmId'] = this.savedpayload.EmId;
    payload['StrId'] = this.savedpayload.StrId;
    payload['SessionId'] = this.savedpayload.SessionId;
    payload['EsParentId'] = this.savedpayload.EsParentId;
    this.umsService.getStuIAAtdSet(payload).subscribe(res => {

      if (res.status) {
        this.Table = true;
        this.SaveBtn = false;
        this.UpdateBtn = true;
        res.data.forEach((element, i) => {
          const creds = this.IAAtdSetting.get('StuArray') as FormArray;
          creds.push(
            this.fb.group({
              SrNo: new FormControl(i + 1),
              EsCode: new FormControl(element.EsCode),
              EsName: new FormControl(element.EsName),
              EsId: new FormControl(element.EsId),
              Attendance: new FormControl(element.Attendance, [Validators.pattern('^(?:99|[0-9]{1,2})([.][0-9]{1,2})?$'), Validators.required]),
              AttSetIAId: new FormControl(element.AttSetIAId),
            })
          );
        });
      }
      else {
        this.getHeads(data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.Table = false;
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });

  }

  getHeads(data) {
    const payload = {};
    payload['EsId'] = data;
    this.umsService.getStuIASub(payload).subscribe(res => {
      if (res.status) {
        this.Table = true;
        this.SaveBtn = true;
        this.UpdateBtn = false;
        this.tableData = res.data;
        this.tableData.forEach((element, i) => {
          const creds = this.IAAtdSetting.get('StuArray') as FormArray;
          creds.push(
            this.fb.group({
              SrNo: new FormControl(i + 1),
              EsCode: new FormControl(element.EsCode),
              EsName: new FormControl(element.EsName),
              EsId: new FormControl(element.EsId),
              Attendance: new FormControl('', [Validators.pattern('^(?:99|[0-9]{1,2})([.][0-9]{1,2})?$'), Validators.required]),
              AttSetId: new FormControl(''),

            })
          );
        });
      }
      else {
        this.Table = false;
        this.SaveBtn = false;
        this.UpdateBtn = false;
        let data = {}
        data['message'] = 'No Practical Heads For This Subject'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.Table = false;
      this.SaveBtn = false;
      this.UpdateBtn = false;
      let data = {}
      data['message'] = 'No Practical Heads For This Subject'
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }


  getAttendance(emid, strid) {
    this.savedpayload = this.IAAtdSetting.value
    this.StuArray = this.IAAtdSetting.get('StuArray') as FormArray;
    this.StuArray.clear();
    const payload = {};
    payload['CgCode'] = this.savedpayload.CgCode;
    payload['CoCode'] = this.savedpayload.CoCode;
    payload['EmId'] = this.savedpayload.EmId;
    payload['StrId'] = this.savedpayload.StrId;
    payload['SessionId'] = this.savedpayload.SessionId;
    this.umsService.getStuIAAtdSet(payload).subscribe(res => {

      if (res.status) {
        this.Table = true;
        this.SaveBtn = false;
        this.UpdateBtn = true;
        // res.data.forEach((element, i) => {
        //   const creds = this.IAAtdSetting.get('StuArray') as FormArray;
        //   creds.push(
        //     this.fb.group({
        //       SrNo: new FormControl(i + 1),
        //       EsCode: new FormControl(element.EsCode),
        //       EsName: new FormControl(element.EsName),
        //       EsId: new FormControl(element.EsId),
        //       Attendance: new FormControl(element.Attendance, [Validators.pattern('^(?:99|[0-9]{1,2})([.][0-9]{1,2})?$')]),
        //       AttSetId: new FormControl(element.AttSetId),
        //     })
        //   );
        // });
      }
      else {
        this.subjects(emid, strid)
      }



    });
  }


  addNewRow() {
    const creds = this.IAAtdSetting.controls.StuArray as FormArray;
    creds.push(
      this.fb.group({
        EsCode: new FormControl(''),
        EsName: new FormControl(''),
        Attendance: new FormControl('', [Validators.pattern('^(?:99|[0-9]{1,2})([.][0-9]{1,2})?$'), Validators.max(100), Validators.required]),
        Status: new FormControl('N'),
        StuId: new FormControl(''),
        SctId: new FormControl(''),
        AttSetId: new FormControl('')
      })
    );
  }

  onInputChange2(val, i) {
    this.saveDisable = false
    this.updateDisable = false
    const tempData = val.target.value;
    let taskListArrays = this.IAAtdSetting.get('StuArray') as FormArray;

    if (tempData > 100) {
      taskListArrays.controls[i].get('Attendance').setErrors({ PercentError: true });
      if (this.SaveBtn == true) {
        this.saveDisable = true
      }
      else if (this.UpdateBtn == true) {
        this.updateDisable = true
      }
    }
    else {
      taskListArrays.controls[i].get('Attendance').setErrors(null);
      if (this.SaveBtn == true) {
        this.saveDisable = false
      }
      else if (this.UpdateBtn == true) {
        this.updateDisable = false
      }
    }
    if (tempData >= 75) {
      this.StuArray = this.IAAtdSetting.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }
    else if (tempData < 75) {
      this.StuArray = this.IAAtdSetting.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('N');
    }
    else if (tempData == '') {
      this.StuArray = this.IAAtdSetting.get('StuArray') as FormArray;
      this.StuArray.at(i).get('Status').setValue('Y');
    }

    if (/[^0-9]/.test(tempData)) {
      taskListArrays.controls[i].get('Attendance').setErrors({ NonNumericError: true });
      if (this.SaveBtn == true) {
        this.saveDisable = true
      }
      else if (this.UpdateBtn == true) {
        this.updateDisable = true
      }
    }
    else {
      taskListArrays.controls[i].get('Attendance').setErrors(null);
      if (this.SaveBtn == true) {
        this.saveDisable = false
      }
      else if (this.UpdateBtn == true) {
        this.updateDisable = false
      }
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  errorcheckR(i) {
    return i.controls['Attendance'].touched && i.controls['Attendance'].errors?.pattern
  }

  LessThan(i) {
    return i.controls['Attendance'].touched && i.controls['Attendance'].errors?.max
  }

  Save(){
    if (this.IAAtdSetting.invalid) {
      this.IAAtdSetting.get('SessionId').markAsTouched();
      this.IAAtdSetting.get('CoCode').markAsTouched();
      this.IAAtdSetting.get('EmId').markAsTouched();
      this.IAAtdSetting.get('EsParentId').markAsTouched();
      this.StuArray = this.IAAtdSetting.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Attendance').markAsTouched();
        })
      }
    }
    else {
      this.SaveAtd()
    }
  }

  SaveAtd() {
    this.spinner.show();
    this.submitpayload = this.IAAtdSetting.value;
    this.IAAtdSetting.controls.StuArray as FormArray;
    this.StuArray = this.IAAtdSetting.get('StuArray') as FormArray;
    this.Student = this.StuArray.value
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.Student.forEach((element, index, array) => {
        let payload = {};
        payload['SessionId'] = this.submitpayload['SessionId'];
        payload['CgCode'] = this.submitpayload['CgCode'];
        payload['CoCode'] = this.submitpayload['CoCode'];
        payload['EmId'] = this.submitpayload['EmId'];
        payload['StrId'] = this.submitpayload['StrId'];
        payload['Attendance'] = parseInt(element.Attendance);
        payload['EsParentId'] = this.submitpayload['EsParentId'];
        payload['EsId'] = parseInt(element.EsId);
        payload['EsName'] = element.EsName;
        payload['EsCode'] = this.SubCode;
        payload['EsHeadCode'] = element.EsCode;
        this.umsService.saveStuIAAtdSet(payload).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        this.spinner.hide();
        let data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable(this.submitpayload['EsParentId'], this.SubCode)
        });

      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable(this.submitpayload['EsParentId'], this.SubCode)
        });
      }
    });
  }

  update(){
    if (this.IAAtdSetting.invalid) {
      this.IAAtdSetting.get('SessionId').markAsTouched();
      this.IAAtdSetting.get('CoCode').markAsTouched();
      this.IAAtdSetting.get('EmId').markAsTouched();
      this.IAAtdSetting.get('EsParentId').markAsTouched();
      this.StuArray = this.IAAtdSetting.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Attendance').markAsTouched();
        })
      }
    }
    else {
      this.updateAtd()
    }
  }

  updateAtd() {

    this.spinner.show();
    this.submitpayload = this.IAAtdSetting.value;
    this.IAAtdSetting.controls.StuArray as FormArray;
    this.StuArray = this.IAAtdSetting.get('StuArray') as FormArray;
    this.Student = this.StuArray.value
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.Student.forEach((element, index, array) => {
        let payload = {};
        payload['SessionId'] = this.submitpayload['SessionId'];
        payload['CgCode'] = this.submitpayload['CgCode'];
        payload['CoCode'] = this.submitpayload['CoCode'];
        payload['EmId'] = this.submitpayload['EmId'];
        payload['StrId'] = this.submitpayload['StrId'];
        payload['EsParentId'] = this.submitpayload['EsParentId'];
        payload['Attendance'] = parseInt(element.Attendance);
        payload['AttSetIAId'] = parseInt(element.AttSetIAId);
        payload['EsId'] = parseInt(element.EsId);
        payload['EsName'] = element.EsName;
        payload['EsCode'] = this.SubCode;
        payload['EsHeadCode'] = element.EsCode;
        this.umsService.updateStuIAAtdSet(payload).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        this.spinner.hide();
        let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable(this.submitpayload['EsParentId'], this.SubCode)
        });

      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.ShowTable(this.submitpayload['EsParentId'], this.SubCode)
        });
      }
    });
  }


}
